<script>
import Nav from "../components/pc/nav.vue";
import Bottom from "../components/pc/bottom.vue";
import Float from "../components/pc/home/float.vue";

export default {
  data() {
    return {
      bannerFixed: false,
      ind: 0,
    };
  },
  components: {
    Nav,
    Bottom,
    Float,
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true;
      } else {
        this.bannerFixed = false;
      }
    },
    change(ind) {
      this.ind = ind;
    },
  },
};
</script>
<template>
  <div class="home">
    <Nav :isFixed="bannerFixed" :defaultInd="4"></Nav>
    <div class="cont">
      <h5>Help Center</h5>
      <img class="banner" src="@/assets/img/notice-sub3.png" alt="" />
      <ul class="nav">
        <li class="nav-item" :class="{ active: ind == 0 }" @click="change(0)">
          Loan Guide
        </li>
        <li class="nav-item" :class="{ active: ind == 1 }" @click="change(1)">
          Repayment Guide
        </li>
        <li class="nav-item" :class="{ active: ind == 2 }" @click="change(2)">
          About OKash&EaseMoni
        </li>
      </ul>
      <div class="tab-item" v-if="ind == 0">
        <p class="q">Who can apply for OKash&EaseMoni loan?</p>
        <p class="a">
          Any adult from 18 to 50 years of age can apply. All you need is your
          BVN and bank account details for loan disbursement.
        </p>
        <p class="q">How can I apply for a loan?</p>
        <p class="a">
          "Borrow in 3 simple steps: <br />
          1. Apply for loan <br />
          Open the OKash&EaseMoni App, click on 'Apply now', complete
          registration, take a selfie and link your bank account for loan
          disbursement. <br />
          2. Initiate a loan <br />
          Select the loan amount and tenure that you want and click on 'Apply
          Now' and confirm your bank account details for disbursement. <br />
          3. Your account is credited <br />
          Your bank account will be credited with the loan within 3 minutes.
          <br />
        </p>
        <p class="q">Don't know your own BVN?</p>
        <p class="a">
          Just dial *565*0#. Please note: This will only works if you are making
          the request from the same phone number currently linked to your bank
          account.
        </p>
        <p class="q">Why the interest rate is different?</p>
        <p class="a">
          The rate will be different ,it depends on your credit evaluation and
          product loyalty. pls keep using our product and fill in more
          information about yourself.
        </p>
        <p class="q">How can I be eligible for coupons?</p>
        <p class="a">
          Please keep a good credit history with OKash&EaseMoni and you can be
          part of the lucky users to enjoy our various discount coupons.
        </p>
        <p class="q">What is the OKash&EaseMoni Revolving loan?</p>
        <p class="a">
          The new OKash&EaseMoni Revolving loan is a product designed to meet
          your every need. The product allows you to borrow multiple times, i.e.
          you can have more than one loan running within your approved credit
          limit. You will also enjoy higher loan amounts at lower interest rate
          and longer tenure.
        </p>
        <p class="q">
          I cannot find the landing page for Revolving loan when I logged in to
          my OKash&EaseMoni App?
        </p>
        <p class="a">
          Kindly go to play store and update your OKash&EaseMoni app. Access to
          revolving loan also depends on the user’s qualifications and repayment
          history on OKash&EaseMoni. You can borrow at least 2 times within your
          approved credit limit.
        </p>
        <p class="q">
          How can I increase my loan limit and tenure and get lower interest?
        </p>
        <p class="a">
          Unlock higher loan amounts, lower interest rates and longer tenure by
          repaying your loans on time with no default.
        </p>
        <p class="q">
          I just borrowed part of my Revolving loan but I still have more limit,
          do I need to repay first before I can borrow another loan?
        </p>
        <p class="a">
          No, you can borrow multiple times within your approved limit and have
          more than one loan running. Keeping a good repayment history can also
          guarantee you a higher amount, a longer period and a lower interest
          rate.
        </p>
        <p class="q">
          What is the difference between Revolving loan and OKash&EaseMoni loan?
        </p>
        <p class="a">
          Revolving loan is a new variant of OKash&EaseMoni that allows you to
          borrow multiple times at lower interest rate and longer tenure.
        </p>
        <p class="q">How can I be eligible for a Revolving loan?</p>
        <p class="a">
          Be a good user of OKash&EaseMoni loan and maintain a good credit
          history.
        </p>
      </div>
      <div class="tab-item" v-if="ind == 1">
        <p class="q">How can I repay my loan?</p>
        <div class="a">
          There are 3 ways to make repayment: Via Bank transfer, USSD and Card
          payment. (See below). <br />
          1. For Card Payment: <br />
          1) Select the loan that needs to be repaid, and click Repay; <br />
          2)Select the card already linked or click on ‘Add card’ to input the
          details of your bank card and then click ‘Make payment’; <br />
          2. Bank Transfer: <br />
          1) Select the loan that needs to be repaid, and click Repay; <br />
          2) Select Bank transfer and click ‘Make payment’; <br />
          3) The transfer number information will be displayed. Go to your
          bank’s mobile or online banking and input the transfer number
          information displayed. Note: Bank transfer repayment may incur delays;
          <br />
          3. USSD repayment: <br />
          1) Select the loan that needs to be repaid and click ‘Repay’ <br />
          2) Select the repayment method as USSD Transfer, and click ‘make
          payment’ <br />
          3) The USSD repayment information will be displayed. Select the
          corresponding bank information, and click ‘DIAL’; <br />
          <p class="q"></p>
          If you are an opay user and have agreed to authorize the relevant
          agreement, you can also check the repayment on the EasyMoni module in
          your opay app; (see picture below). <br />
          Opay app repayment: <br />
          1) The loan that needs to be repaid will be displayed. Select the
          ‘Opay’ for repayment, and click ‘Make payment’; <br />
          2) Your OPay account information will be displayed, select Balance or
          Owealth for repayment, and click ‘Payment’; <br />
          <p class="q"></p>
          Please refer to the above guide to make your loan repayment;
        </div>
        <p class="q">Can I repay the loan before due date?</p>
        <p class="a">Yes, but you still need to pay all the interest amount.</p>
        <p class="q">What happens if I pay my loan late?</p>
        <p class="a">
          Late loan repayments automatically incur a rollover interest up to 2%
          per day. It is therefore advised that one does not exceed the
          repayment period. Furthermore, this could reduce your future borrowing
          credit score.
        </p>
      </div>
      <div class="tab-item" v-if="ind == 2">
        <p class="q">Introduction of OPay MFB</p>
        <p class="a">
          1.Established in 2009, with CBN approved MFB license, providing safe
          and reliable banking services. <br />
          2.The total number of registered users is 4 million. <br />
          3.More than 2,000 regular employees in Nigeria, 80% of whom have
          university degrees.
        </p>
        <p class="q">Secure encryption</p>
        <p class="a">
          1.Make sure you apply in person through face recognition. <br />
          2.Cooperate with insurance companies to insure all card-bound users.
          <br />
          3.Bank-level security technology, safe and secure.
        </p>
      </div>
    </div>
    <Bottom></Bottom>
    <Float />
    <el-backtop target=".home"></el-backtop>
  </div>
</template>
<style lang="scss" scoped>
.home {
  height: 100%;
}
.cont {
  padding: 148px 120px 72px;
  h5 {
    color: rgba(0, 0, 0, 0.85);
    font-size: 40px;
    font-weight: 500;
    line-height: 40px;
    position: relative;
  }
  .banner {
    width: 100%;
    margin: 31px 0 40px;
  }
}

.nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  li {
    margin-right: 84px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -1px;
    cursor: pointer;
    &.active {
      position: relative;
      font-weight: bold;
      color: #210f60;
      border-bottom: 4px solid #1c58f5;
    }
  }
}
.tab-item {
  padding-top: 48px;
  .q {
    color: rgba(0, 0, 0, 0.85);
    font-size: 24px;
    font-weight: 500;
  }
  .a {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    margin: 15px 0 60px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
